import * as React from 'react';
import * as queryString from 'query-string';
import ReactModal from 'react-modal';

import * as sessionUtils from 'login-utils/sessionUtils';
import * as trackingAPI from 'login-apis/trackingAPI';

import { AccessibilityAnnouncer, accessibilityUtils } from '@blend/consumer-components';
import { utils } from '@blend/ui-common';

import { WindowWrapper } from 'login-utils/globalWrappers';
import MobileWatcher from '../MobileWatcher';
import NonProdWarningBar from '../NotificationBar/NonProdWarningBar';
const { modalUtils, performanceUtils } = utils;

type LoginWrapperProps = ReactRouter.RouteComponentProps<{}, {}>;

/*
 * This component is a wrapper around the entire app (but below the error boundary)
 * that is used by pingdom to monitor uptime.
 */
export default class LoginWrapper extends React.PureComponent<LoginWrapperProps> {
  componentDidMount() {
    const { location } = this.props;
    sessionUtils.saveQueryToSession(queryString.parse(location.search));

    if (WindowWrapper.timePerformance) {
      trackingAPI.logEvent('performance.appLoad', { duration: performance.now() });
      performanceUtils.setupPerformanceMetricListeners(trackingAPI);
      WindowWrapper.timePerformance = false;
    }

    modalUtils.setupAccessibility(ReactModal.setAppElement, '#root');
    accessibilityUtils.addHighlightOnTabListeners();
  }

  render() {
    const { children } = this.props;
    return (
      <div id="pingdom-transaction-check">
        <NonProdWarningBar />
        <MobileWatcher />
        <AccessibilityAnnouncer />

        {children}
      </div>
    );
  }
}
